import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'app-hulk-config-checkbox',
  templateUrl: './hulk-config-checkbox.component.html',
  styleUrls: ['./hulk-config-checkbox.component.scss']
})
export class HulkConfigCheckboxComponent implements OnInit {

  @Input() oneColumn:any;
  @Input() attributes: any;
  @Input() label: any;

  constructor() { }

  ngOnInit() {
  }

}
